module.exports = __webpack_public_path__ + "img/completion_right.0fb3c7c7.jpg";